__webpack_require__.p = "/testimonials-grid-section-project/";